export default {
    grupo_perguntas: [],
}